import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGuide } from '../../hooks/useGuide';

const STEPS = [
  { title: 'Find your polling place', body: "We'll show you exactly where to go and when." },
  {
    title: "See what's on your ballot",
    body: 'Every race and measure — nothing hidden, nothing skipped.',
  },
  { title: 'Research and decide', body: 'Read plain-English summaries. Take your time.' },
  {
    title: 'Print your cheat sheet',
    body: 'Leave with a ready-to-use reference for the booth.',
  },
];

export default function GuidePlan() {
  const navigate = useNavigate();
  const { lookupResult } = useGuide();

  useEffect(() => {
    if (!lookupResult) navigate('/', { replace: true });
  }, [lookupResult, navigate]);

  if (!lookupResult) return null;

  return (
    <div>
      <p className="g-label">Step 1 of 4</p>
      <h1 className="g-h1">Here's the plan.</h1>
      <p className="g-body">
        Four things. Takes about 10 minutes. You'll walk in knowing exactly what you're voting on.
      </p>

      <div className="g-card" style={{ marginBottom: 24 }}>
        {STEPS.map((step, i) => (
          <div className="g-step-row" key={step.title}>
            <div className="g-step-num">{i + 1}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 17, marginBottom: 2 }}>{step.title}</div>
              <div style={{ fontSize: 14, color: 'var(--g-muted)' }}>{step.body}</div>
            </div>
          </div>
        ))}
      </div>

      <button className="g-btn-primary" onClick={() => navigate('/guide/polling-place')}>
        Let's go →
      </button>
    </div>
  );
}
